export default __webpack_public_path__ + "static/media/partners-logo-ewha-w@3x.23ca95b4.png";